export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/family/query`,
          data
        });
      },
      /**
       * 获取家人详情
       * @param data
       * @return {*}
       */
      getFamilyInfo(data) {
          return http.json({
              url: `/family/get?id=${data.id}`
          })
      },
      /**
       * 删除家人
       * @param data
       * @return {*}
       */
      removeFamily(data) {
          return http.json({
              url: `/family/delete?id=${data[0].id}`,
              data
          })
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/family.js